import React from 'react';
import classNames from 'classnames';

import styles from '../MobileCard.module.scss';

import { MobileCardData, MobileField, MobileFieldsOfLane } from '../../types';
import { Title } from './Title';

export function Link<D extends MobileCardData>(
    field: MobileField<D>,
    dataItem: D,
    onLinkClick: (e: React.MouseEvent) => void,
): React.ReactElement<any> {
    return (
        <div
            className={classNames([
                styles.field,
                field.isPrimary && styles.fieldPrimary,
                field.fieldsOnLane === MobileFieldsOfLane.SingleField && styles.singleOnLane,
                field.fieldsOnLane === MobileFieldsOfLane.PairField && styles.pairOnLane,
            ])}
        >
            {!field.withoutTitle && Title(field, dataItem)}
            <div
                id={dataItem.id}
                className={classNames([styles.textValue, field.isPrimary && styles.textValuePrimary])}
            >
                <a
                    className={styles.link}
                    href={dataItem.link}
                    onClick={onLinkClick}
                >
                    {(dataItem[field.accessor] as React.ReactNode) ?? dataItem.visitTime}
                </a>
            </div>
        </div>
    );
}
